import { Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class PageStatusService {

  private _isHomePage = false;
  private isAllOperationsPage = false;

  showLocationFab = [
    "/operations",
    "/create-trajectory",
  ]

  showFabWindy = [
    "/operations",
    "/create-trajectory",
  ]

  set isHomePage(value: boolean) {
    this._isHomePage = value;
  }

  get isHomePage(): boolean {
    return this._isHomePage;
  }

  constructor(
    private router: Router,
  ) { }

  getIsAuthPage(): boolean {
    return this.router.url === '/auth';
  }

  isDroneOperatorHomePage(): boolean {
    return this.router.url === '/operations';
  }

  isNewOpRequestMenuPage(): boolean {
    return this.router.url === '/new-trajectories-page';
  }

  isNewTrajectoryMenuPage(): boolean {
    return this.router.url === '/new-trajectories-page';
  }

  isCreateTrajectoryPage(): boolean {
    return this.router.url === '/create-trajectory';
  }

  isInfraestructureOperatorHomePage(): boolean {
    return this.router.url === '/operation-request-detail' || this.router.url.includes('/operation-request-detail');
  }

  isInfrastructureDetailsPage(): boolean {
    return this.router.url.includes('/operation-request-detail');
  }

  isOperationRequestDetailPage(): boolean {
    return this.router.url.includes('/operation-request-detail');
  }

  isTodayOperationsPage(): boolean {
    return this.router.url === '/ap-operations' || this.router.url === '/scheduled-operations';
  }

  isTodayCoordinationPage(): boolean {
    return this.router.url === '/todayCoordinations' || this.router.url.includes('/scheduled-operations');
  }

  isRequestDetailsPage(): boolean {
    return this.router.url.includes('/details') || this.router.url.includes('/operation-details');
  }

  isConfirmationPage(): boolean {
    return this.router.url === '/oprequest-confirmation' || this.router.url.includes('/confirmation');
  }

  shouldShowWindyFab(): boolean{
    const currentRouteWithoutParams = this.router.url.split('/')[1];
    return this.showFabWindy.some(route => route.includes(currentRouteWithoutParams));
  }

  shouldShowLocationFab(): boolean {
    return this.showLocationFab.some(route => {
      return this.router.url === route || // Check if the current route matches exactly
            (this.router.url.startsWith(route) && this.router.url.split('/').filter(s => s).length === 1);
            // Check if the current route starts with the route and has no additional segments
    });
  }
}
